import { PlusOutlined } from "@ant-design/icons";
import { Button, ButtonProps } from "antd";
import { DrawerLink } from "components/UI/DrawerLink";
import {usePaldockTranslation} from "hooks/usePaldockTranslation.tsx";
import { DrawerId } from "types/models.ts";

interface AddButtonProps {
    drawerId: DrawerId;
    type?: ButtonProps["type"];
    size?: ButtonProps["size"];
    className?: string;
}

export const AddButton = ({ drawerId, type = "primary", size = "small", className = "px-4 py-3" }: AddButtonProps) => {
    const { t } = usePaldockTranslation("common");
    if (!drawerId) {
        return null;
    }
    return (
        <DrawerLink drawerId={drawerId} action="show">
            <Button type={type} size={size} className={className}>
                <PlusOutlined /> {t("add")}
            </Button>
        </DrawerLink>
    );
};
